import { Wordmark } from "@chai/ui";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="flex items-center justify-between px-6 py-5">
        <Wordmark />
      </header>
      <main className="mx-auto flex w-full max-w-[420px] flex-1 flex-col gap-6 px-6 pb-16">
        <Outlet />
      </main>
      <footer className="px-6 py-4 text-center">
        <p className="meta-strip">Chaidojo</p>
      </footer>
    </div>
  );
}
